export default __webpack_public_path__ + "purchase-accompanying-truck.png?e17f6f25ad37f9274026dfc22ace14e9";